import { render, staticRenderFns } from "./device.vue?vue&type=template&id=2b848e9d&scoped=true&"
import script from "./device.vue?vue&type=script&lang=js&"
export * from "./device.vue?vue&type=script&lang=js&"
import style0 from "./device.vue?vue&type=style&index=0&id=2b848e9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b848e9d",
  null
  
)

export default component.exports